import { createSlice, PayloadAction } from "@reduxjs/toolkit"

export interface VNZAuthState {
  // access token
  accessToken: string
  isAuthenticated: boolean
  isAuthenticating: boolean
  hasAuthenticationError: boolean
  authenticationError: string
  // refresh token
  refreshToken: string
  isRefreshingToken: boolean
  expiryDate: string
  expiresIn: number
  hasRefreshTokenError: boolean
  refreshTokenError: string
}

const initialState: VNZAuthState = {
  accessToken: "",
  isAuthenticated: false,
  isAuthenticating: false,
  hasAuthenticationError: false,
  authenticationError: "",

  refreshToken: "",
  isRefreshingToken: false,
  expiryDate: "",
  expiresIn: 0,
  hasRefreshTokenError: false,
  refreshTokenError: "",
}

export interface SetIsAuthenticatingPayload {
  isAuthenticating: boolean
}

export interface SetIsAuthenticatedPayload {
  accessToken: string
  refreshToken: string
  expiryDate: string
  expiresIn: number
}

export interface SetAuthenticationErrorPayload {
  authenticationError: string
}

export interface RefreshAuthenticationTokenPayload {}

export interface SetRefreshTokenErrorPayload {
  refreshTokenError: string
}

export const VNZAuth = createSlice({
  name: "VNZAuth",
  initialState,
  reducers: {
    setIsAuthenticating(
      state: VNZAuthState,
      action: PayloadAction<SetIsAuthenticatingPayload>
    ) {
      const { isAuthenticating } = action.payload
      state.isAuthenticating = isAuthenticating
      state.isAuthenticated = false
      state.hasAuthenticationError = false
      state.authenticationError = ""
    },
    setIsAuthenticated(
      state: VNZAuthState,
      action: PayloadAction<SetIsAuthenticatedPayload>
    ) {
      const { accessToken, refreshToken, expiryDate, expiresIn } =
        action.payload
      state.isAuthenticating = false
      state.isAuthenticated = true
      state.accessToken = accessToken
      state.refreshToken = refreshToken
      state.expiryDate = expiryDate
      state.expiresIn = expiresIn
      state.hasAuthenticationError = false
      state.authenticationError = ""
      state.isRefreshingToken = false
      state.hasRefreshTokenError = false
      state.refreshTokenError = ""
    },
    logout(state: VNZAuthState) {
      state.isAuthenticating = false
      state.isAuthenticated = false
      state.accessToken = ""
      state.refreshToken = ""
      state.expiryDate = ""
      state.expiresIn = 0
      state.hasAuthenticationError = false
      state.authenticationError = ""
      state.isRefreshingToken = false
      state.hasRefreshTokenError = false
      state.refreshTokenError = ""
    },
    restoreAuthenticationState(state: VNZAuthState) {},
    refreshAuthenticationToken(
      state: VNZAuthState,
      _action: PayloadAction<RefreshAuthenticationTokenPayload>
    ) {
      state.isRefreshingToken = true
      state.hasRefreshTokenError = false
      state.refreshTokenError = ""
    },
    setRefreshTokenError(
      state: VNZAuthState,
      action: PayloadAction<SetRefreshTokenErrorPayload>
    ) {
      const { refreshTokenError } = action.payload
      state.isRefreshingToken = false
      state.hasRefreshTokenError = true
      state.refreshTokenError = refreshTokenError
    },
    setAuthenticationError(
      state: VNZAuthState,
      action: PayloadAction<SetAuthenticationErrorPayload>
    ) {
      const { authenticationError } = action.payload
      state.isAuthenticating = false
      state.isAuthenticated = false
      state.accessToken = ""
      state.hasAuthenticationError = true
      state.authenticationError = authenticationError
    },
  },
})
